import React, { createContext, useContext, useState } from 'react'

const DigitalProductStoreWithdrawBottomSheetContext = createContext()

export const DigitalProductStoreWithdrawBottomSheetProvider = ({
  children,
  ...rest
}) => {
  const { isWithdrawing, setIsWithdrawing } = rest

  return (
    <DigitalProductStoreWithdrawBottomSheetContext.Provider
      value={{ isWithdrawing, setIsWithdrawing }}
    >
      {children}
    </DigitalProductStoreWithdrawBottomSheetContext.Provider>
  )
}

export const useDigitalProductStoreWithdrawBottomSheet = () => {
  const context = useContext(DigitalProductStoreWithdrawBottomSheetContext)
  if (!context) {
    throw new Error(
      'useDigitalProductStoreWithdrawBottomSheet must be used within a DigitalProductStoreWithdrawBottomSheetProvider'
    )
  }
  return context
}
